import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "../components/ui/button";
import { PublicLayout } from "../components/PublicLayout";

const NotFoundPage = () => (
  <PublicLayout>
    <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center" data-testid="not-found-page">
      <Compass className="h-14 w-14 text-hz-cyan" />
      <h1 className="mt-6 text-4xl font-extrabold tracking-tight text-hz-navy">404</h1>
      <p className="mt-3 text-base text-hz-ink/70">
        La página que buscas no existe o fue movida.
      </p>
      <Link to="/" className="mt-8">
        <Button data-testid="not-found-home-btn" className="bg-hz-cyan font-bold text-white hover:bg-hz-blue">
          Volver al inicio
        </Button>
      </Link>
    </div>
  </PublicLayout>
);

export default NotFoundPage;
